export const stateName = 'shippingContact';
export let FieldName;

(function (FieldName) {
  FieldName["ShippingContact"] = "shipping_contact";
  FieldName["BuyerPhoneNumber"] = "buyer_phone_number";
  FieldName["SellerPhoneNumber"] = "seller_phone_number";
})(FieldName || (FieldName = {}));